var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M21 12c-1.889 2.991-5.282 6-9 6s-7.111-3.009-9-6c2.299-2.842 4.992-6 9-6s6.701 3.158 9 6z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Eye.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Eye;

Eye.default = Eye;
